/**
 * Avatar component
 *
 * Renders a user avatar image with configurable shape and size.
 *
 * @param {object} props
 *
 * @param {string} props.picture
 *   The image URL for the avatar.
 *
 * @param {"rounded" | "square"} [props.shape="rounded"]
 *   The shape of the avatar. Use "rounded" for a fully circular avatar or
 *   "square" for a square avatar.
 *
 * @param {"sm" | "md" | "lg" | "xl" | "2xl"} [props.size="2xl"]
 *   The size of the avatar, typically mapped to predefined Tailwind CSS
 *   width/height classes.
 */
export default function Avatar({ picture, shape = "rounded", size = "2xl" }) {
  const sizeMap = {
    md: "w-scale-md h-scale-md",
    lg: "w-scale-lg h-scale-lg",
    xl: "w-scale-xl h-scale-xl",
    "2xl": "w-scale-2xl h-scale-2xl",
  };

  let shapeClass;
  if (shape === "square") {
    if (size === "md" || size === "lg") shapeClass = "rounded-sm";
    else if (size === "xl") shapeClass = "rounded-md";
    else shapeClass = "rounded-lg";
  } else if(shape === "rounded") {
    shapeClass = "rounded-round";
  } else {
    shapeClass = shape;
  }

  return (
    <div className="inline-block overflow-hidden">
      <img
        src={picture}
        alt="avatar"
        className={`bg-white object-cover flex-shrink-0 ${sizeMap[size] || size} ${shapeClass}`}
      />
    </div>
  );
}
